export default {"src":"/uk/_next/static/media/cloud-tick.87edafd0.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};